import React from 'react';
import KnowledgeDetailContain from '../../Componant/Knowledgebase/KnowledgeDetails';

const KnowledgeDetail = () => {
  return (
    <div className='page-body'>
      <KnowledgeDetailContain />
    </div>
  );
};

export default KnowledgeDetail;
